import { render, staticRenderFns } from "./IndicatorsForm.vue?vue&type=template&id=00bb39bc&"
import script from "./IndicatorsForm.vue?vue&type=script&lang=js&"
export * from "./IndicatorsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports